










































































































































import {Component, Vue} from 'vue-property-decorator';
import {ObjectFactory} from '../../config/objectFactory';
import {AddMemberRequest} from '../../types/request';
import {validationMixin} from 'vuelidate';
import {email, integer, minLength, required} from 'vuelidate/lib/validators';
import {MedTransGoConstants} from '../../util/constants';
import {ToastEvent} from '../../types/event';
import {CommonUtils} from '../../util/commonUtils';
import {EventBus} from '../../main';
import {OrgLocation} from '../../types/entity';
import {MemberProfile} from '../../types/response';

@Component({
    mixins: [validationMixin],
    data() {
        return {
            firstName: '',
            lastName: '',
            email: '',
            externalId: '',
            phone: '',
            location: '',
            managedLocations: [],
            memberType: 'ORG_MANAGER',
            maximumAllowedSubmission: 0,
            isRequestLimit: false,
            isRestrictedView: false,
            isApprovalRequired: false,
        };
    },
    computed: {
        isUNCUser() {
            return ObjectFactory.getUNCService().isUNCSubdomain();
        },
    },
    validations() {
        const rules = {
            firstName: {
                required,
                regex: (fullName: string) => /^[a-zA-Z ]+$/.test(fullName),
            },
            lastName: {
                required,
                regex: (fullName: string) => /^[a-zA-Z ]+$/.test(fullName),
            },
            email: {
                required,
                email,
            },
            phone: {
                required,
                minLength: minLength(10),
                regex: (phone: string) => MedTransGoConstants.PHONE_REGX.test(phone),
            },
            location: {
                required,
            },
            maximumAllowedSubmission: {
                required,
                integer,
            },
            managedLocations: {},
        };
        if ((!this.$data.isRequestLimit && this.$data.memberType === 'ORG_CUSTOMER') || this.$data.memberType !== 'ORG_CUSTOMER') {
            delete rules.maximumAllowedSubmission;
        }
        return rules;
    },
})
export default class AddMemberModal extends Vue {
    private show = true;

    private locations: OrgLocation[] | undefined = [];
    private isLienEnabled = false;
    private memberProfile: MemberProfile | undefined;
    private isMemberType = false;

    public mounted() {
        this.memberProfile = ObjectFactory.getCacheService().getMemberInfo();
        if (this.memberProfile && this.memberProfile.memberType === 'ORG_MANAGER') {
             this.isMemberType = true;
        }
        this.getOrganizationLocations();
        this.getOrganization();
    }

    /**
     * @author <Aniket.P>
     * @description API - Returns organization locations
     * @param req {Request} - Express Request
     * @param res {Response} - Express Response - list of locations
     * @returns List of oragnazation lists
     * @throws InvalidRequestException if organization id is invalid
     */
    private async getOrganizationLocations() {
        if (!this.locations || this.locations.length <= 0) {
            const memberProfile = ObjectFactory.getCacheService().getValue(
                MedTransGoConstants.FIELD_MEMBER_PROFILE,
            ) as MemberProfile;
            if (memberProfile.organization) {
                const response = await ObjectFactory.getOrganizationService().getLocations(this.$store.state.serverUrl);
                if (response.success && response.data) {
                    response.data.sort((a, b) =>
                        (a.locationName || '').localeCompare(b.locationName || ''),
                    );
                    this.locations = response.data;
                } else {
                    CommonUtils.showError(response);
                }
            }
        }
    }

    private async getOrganization() {
        const organization = await ObjectFactory.getOrganizationService().
        getOrgDetailsById(this.$store.state.serverUrl);
        if (organization && organization.data && organization.data.lienCustomerEnabled) {
            this.isLienEnabled = true;
        }
    }

    /**
     * @author <Amol.D>
     * @description - add new member
     * @param req {Request} - calls add member API
     * @param res {Response} - Express Response - success result
     * @returns member list
     * @throws InvalidRequestException if member already exists
     */
    private async addMember() {
        const addMemberRequest: AddMemberRequest = {
            fullName: this.$data.firstName + ' ' + this.$data.lastName,
            email: this.$data.email,
            externalId: this.$data.externalId || undefined,
            phone: this.$data.phone,
            locationId: this.$data.location,
            managedLocationIds: (this.$data.managedLocations || []).map((ml: OrgLocation) => ml.id),
            memberType: this.$data.memberType,
            maximumAllowedSubmission: this.$data.maximumAllowedSubmission,
            isRestrictedView: this.$data.isRestrictedView,
            isApprovalRequired: this.$data.isApprovalRequired,
        };
        if (this.$data.memberType !== 'ORG_MEMBER') {
            delete addMemberRequest.isApprovalRequired;
        }
        if (this.$data.memberType !== 'ORG_CUSTOMER') {
            delete addMemberRequest.maximumAllowedSubmission;
        }
        if (this.$data.memberType !== 'ORG_MANAGER' && this.$data.memberType !== 'ORG_MEMBER') {
            delete addMemberRequest.managedLocationIds;
        }
        const response = await ObjectFactory.getMemberService().addMember(this.$store.state.serverUrl,
            addMemberRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: CommonUtils.translateMessageCode('MSG_ADD_MEMBER'),
                title: 'Success!',
                timeout: 2000,
                varient: 'success',
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.close();
        } else {
            CommonUtils.showError(response);
        }
    }

    private async togglePermission() {
        this.$data.isRestrictedView = !this.$data.isRestrictedView;
    }

    private async phoneNumberMask() {
        const replaceInput = this.$data.phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        this.$data.phone = !replaceInput[2] ? replaceInput[1] :
            replaceInput[1] + '-' + replaceInput[2] + (replaceInput[3] ? '-' + replaceInput[3] : '');
    }

    private close() {
        this.$router.push({
            name: MedTransGoConstants.VIEW_SETTING_NAME,
        });
    }

    private handleChangeLocation(event: any) {
        const location = (this.locations || []).find((loc: OrgLocation) => loc.id === event.target.value);
        if (location) {
            if (this.$data.managedLocations && this.$data.managedLocations.length > 0) {
                if (!this.$data.managedLocations.includes(location)) {
                    this.$data.managedLocations.push({
                        id: location.id,
                        locationName: location.locationName,
                    });
                }
            } else {
                this.$data.managedLocations = [{
                    id: location.id,
                    locationName: location.locationName,
                }];
            }
        }
    }
}
